import { useTranslation } from 'i18n';
import { Suspense } from 'react';
import { CardsListSkeleton, Grid, Typography } from 'ui';

import { useGetBuyerMaterialSpecificationsAsAdmin } from '../../hooks/useGetBuyerMaterialSpecificationsAsAdmin/useGetBuyerMaterialSpecificationsAsAdmin';
import { BuyerMaterialSpecificationItem } from '../BuyerMaterialSpecificationItem/BuyerMaterialSpecificationItem';

type Props = {
  tradeCompanyId: number;
};

const ListSuspense = () => {
  return <CardsListSkeleton cardCount={3} cardRows={1} />;
};

export const BuyerMaterialSpecificationList = ({ tradeCompanyId }: Props) => {
  const { t } = useTranslation('orders');
  const { data: buyerMaterialSpecifications } = useGetBuyerMaterialSpecificationsAsAdmin({ tradeCompanyId });

  return (
    <Suspense fallback={<ListSuspense />}>
      {buyerMaterialSpecifications.length === 0 ? (
        <Typography>{t('buyerMaterialSpecifications.list.empty')}</Typography>
      ) : (
        <Grid container>
          {buyerMaterialSpecifications.map((spec) => (
            <Grid
              key={spec.id}
              size={{
                md: 4,
                xs: 12,
              }}
            >
              <BuyerMaterialSpecificationItem key={spec.id} buyerMaterialSpec={spec} />
            </Grid>
          ))}
        </Grid>
      )}
    </Suspense>
  );
};
